import { Button } from '@design-system/button';
import { ExtendableImage } from '@design-system/extendable-image';
import { HeadingBlock } from '@design-system/heading-block';
import React, { FC } from 'react';

import { ThankYouProps } from './models';

const ThankYou: FC<ThankYouProps> = ({
  closeButtonLabel,
  heading,
  image,
  closeHandler,
}) => {
  const ariaId = `thankyou-${Math.random().toString(36).substring(2, 8)}`;

  return (
    <>
      <div className="thank-you-overlay" />
      <div
        className="thank-you"
        role="dialog"
        aria-labelledby={`${ariaId}__headline`}
        aria-describedby={`${ariaId}__description`}
        aria-modal="true"
      >
        <div className="thank-you__content">
          <HeadingBlock {...heading} ariaId={ariaId} />
          {image ? (
            <div className="thank-you__content-image">
              <ExtendableImage {...image} />
            </div>
          ) : null}
        </div>
        <Button
          className="thank-you__close"
          variant="subtle-icon"
          size="large"
          iconPrefix={{ props: { icon: 'close' } }}
          onClick={closeHandler}
          autoFocus
        >
          {closeButtonLabel}
        </Button>
      </div>
    </>
  );
};

export default ThankYou;
